'use client';
import { lines } from '@s7/utils';

class ResponseStreamsSupportError extends Error {
    constructor(){
        super(lines('Отслеживание прогресса загрузки требует поддержки `ReadableStream`.', '`ReadableStream` недоступен в вашем окружении.'));
        Object.setPrototypeOf(this, ResponseStreamsSupportError.prototype);
    }
}

export { ResponseStreamsSupportError };
//# sourceMappingURL=ResponseStreamsSupportError.js.map
